// Pricing tiers used across the pricing picker, paymentService, and Edge Functions.
// `productType` values must match what the webhook + verify functions write to user_payments.product_type.

export const PLANS = {
  trial: {
    id: 'trial',
    name: 'Try It',
    tagline: '£1 for your first month, then £4.99/mo',
    amountPence: 100,
    amountLabel: '£1',
    cadence: 'first month',
    // This is a subscription under the hood — first invoice discounted to £1 via a
    // one-time Stripe coupon, then renews at £4.99/month automatically.
    mode: 'subscription',
    productType: 'subscription_pro_trial',
    features: [
      'Unlimited PRDs for the first month',
      'Full prompt downloads',
      'Then £4.99/month automatically',
      'Cancel anytime in-app',
    ],
    cta: 'Start for £1',
  },
  monthly: {
    id: 'monthly',
    name: 'Pro',
    tagline: 'Build as much as you want',
    amountPence: 499,
    amountLabel: '£4.99',
    cadence: '/month',
    mode: 'subscription',
    productType: 'subscription_pro',
    features: [
      'Unlimited PRD generations',
      'All AI-powered tools',
      'Project dashboard',
      'Cancel anytime',
    ],
    cta: 'Subscribe £4.99/mo',
    highlight: true,
  },
  lifetime: {
    id: 'lifetime',
    name: 'Lifetime',
    tagline: 'Pay once, use forever',
    amountPence: 5000,
    amountLabel: '£50',
    cadence: 'one-time',
    mode: 'payment',
    productType: 'lifetime_access',
    features: [
      'Everything in Pro',
      'Unlimited generations forever',
      'No subscription, no renewal',
      'Best long-term value',
    ],
    cta: 'Get lifetime access',
  },
};

export const PLAN_ORDER = ['trial', 'monthly', 'lifetime'];
export const UPGRADE_PLAN_ORDER = ['monthly', 'lifetime'];

export function getPlan(planId) {
  return PLANS[planId] || null;
}

export function isValidPlanId(planId) {
  return Boolean(PLANS[planId]);
}
